module.exports = __webpack_public_path__ + "img/main-september.26cf4ce5.jpg";